// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
//
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
//
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
//
// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App-backup';
// import reportWebVitals from './reportWebVitals';
//
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <React.StrictMode>
//         <App />
//     </React.StrictMode>
// );
//
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
//


// Load the shims first so `window.electron` is populated before any renderer
// module (Redux slices, App, etc.) reads it at import time.
//
// Both shims are imported unconditionally. Each has a guard at the top:
//   - capacitor-shim only runs if window.Capacitor.isNativePlatform()
//   - web-electron-shim only runs if window.electron isn't already set with .db
// So on native: capacitor-shim runs → web-shim no-ops.
// On web/Electron: capacitor-shim no-ops → web-shim runs (or Electron's preload
// already won and web-shim no-ops too).
//
// Order matters: capacitor-shim must run BEFORE web-shim so its `__native`
// marker is in place when web-shim checks.
//
// analyticsClient registers window.__mixgoatPh (posthog-js transport) that
// both shims' analytics stubs forward to; it must load before the first
// analytics call, not before the shims themselves.
import './analyticsClient.js';
import './capacitor-shim.js';
import './web-electron-shim.js';
// after the shims: polls the live Apple-only artwork mode through window.electron
import './renderer/utils/appleArtworkMode';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './renderer/styles/index.css';
import App from './renderer/App';
import reportWebVitals from './renderer/reportWebVitals';
import { Provider } from 'react-redux'; // Import Provider from react-redux
import store from './renderer/redux/store'; // Import the Redux store
import { ErrorBoundary } from './renderer/components/ErrorBoundary';
import { reportError } from './renderer/utils/reportError';
import { isEmptySrcMediaError } from './renderer/utils/isEmptySrcMediaError';

// Suppress audio/video media errors from triggering React's dev error
// overlay. DO NOT call stopPropagation / stopImmediatePropagation here:
// this is a CAPTURE-phase listener on window, and stopping propagation
// prevents the event from ever reaching the audio element's at-target
// `error` handler — which is exactly where jinke's library hooks in to
// fire the `onAudioError` callback in MusicPlayer. That callback owns
// cache-invalidation, list-context advance on stream failure, and the
// sample-preview fallback. Killing it leaves the bottom-player spinner
// stuck forever on every CDN 503 / format-error.
//
// `preventDefault()` is enough to suppress the dev overlay without
// breaking the rest of the audio error pipeline.
window.addEventListener('error', (event) => {
    const target = event.target || event.srcElement;
    if (target && (target.tagName === 'AUDIO' || target.tagName === 'VIDEO')) {
        event.preventDefault();
        // Don't log the benign "no track loaded yet" empty-src state — only
        // genuine playback failures.
        if (!isEmptySrcMediaError(target)) {
            console.warn('[Root] Suppressed media error:', target.error?.message || 'Unknown error');
        }
        return;
    }
    if (event.error) {
        reportError(event.error, { type: 'uncaughtError' });
    }
}, true);

window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const err = reason instanceof Error ? reason : new Error(String(reason));
    reportError(err, { type: 'unhandledRejection' });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <Provider store={store}> {/* Wrap the App with Provider */}
            <ErrorBoundary>
                <App />
            </ErrorBoundary>
        </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

